import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoriaHipoModel } from 'src/app/models/categoria-hipo/CategoriaHipoModel';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ICategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/ICategoriaHipoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CategoriaHipoService } from 'src/app/services/categoria-hipo/categoria-hipo.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  templateUrl: './configuracion-categoria-hipo-editar.component.html',
  styleUrls: ['./configuracion-categoria-hipo-editar.component.css']
})
export class ConfiguracionCategoriaHipoEditarComponent implements OnInit {
  id: number = 0;
  model: ICategoriaHipoModel = new CategoriaHipoModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private serviceCategoriaHipo: CategoriaHipoService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.serviceCategoriaHipo.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.serviceCategoriaHipo.update(this.model).subscribe((data) => {
            this.alertDialogService.open("La categoría fue actualizada");
            this.router.navigate(['/configuracion', 'categorias-hipo']);  
          });
        }
      });
    }
  }
}
